














import Widget from "@/components/common/Widget.vue";
import VerticalSingleBar from "@/components/charts/VerticalSingleBar.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";

import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    VerticalSingleBar,
  },
})
export default class EBITDAGesamt extends Vue {
  public static id = "EBITDAGesamt";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return EBITDAGesamt.id;
  }
  get _dprops() {
    return EBITDAGesamt.dprops;
  }
}
